var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"npc-card",class:{
      center: _vm.center,
      transparent: _vm.transparent
    }},[(_vm.image)?_c('img',{class:{
      portrait: _vm.portrait,
      noZoom: _vm.noZoom
    },style:({order: _vm.right ? 1 : 0}),attrs:{"src":_vm.notAsset ? _vm.image : require('../assets/' + _vm.image)}}):_vm._e(),(_vm.iframe)?_c('iframe',{staticClass:"iframe",class:{noText: _vm.noText},style:({order: _vm.right ? 1 : 0}),attrs:{"allowfullscreen":"","src":_vm.iframe}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }